$(document).ready(function()
{

  var acc = document.getElementsByClassName("toggleTitle");
  var i;
  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
      this.classList.toggle("active");
      this.classList.toggle("arrow-open");
      var toggleContent = this.nextElementSibling;
      if (toggleContent.style.display === "block") {
        toggleContent.style.display = "none";
      } else {
        toggleContent.style.display = "block";
      }
    });
  }
})

function navigationMenuSection(){
  const navigationMenus = document.querySelectorAll('.navigation-menu');
  console.log('navigationMenus', navigationMenus);

  navigationMenus.forEach(item => {
      const menuTrigger = item.querySelector('.mobile-menu-trigger');

      menuTrigger.addEventListener('click', () => {
        console.log('click insection-blocks__accordion-item ')
        navigationMenus.forEach(otherItem => {
          if (otherItem !== item) {
            otherItem.classList.remove('active');
          }
        });

        item.classList.toggle('active');
      });
  });
}

document.addEventListener('DOMContentLoaded', (evt) => {
  navigationMenuSection();

  var isSafari = /^Apple/.test(navigator.vendor) && !/CriOS|FxiOS/.test(navigator.userAgent);
  
  if (isSafari) {
      document.querySelector('body').classList.add('is-safari');
  }
})

// Fix PDP Button on scroll
function addtoCartCheckScroll() {
  var scrollPosition = window.scrollY;
  var PDPaddtoCartForm = document.querySelector("body:not(.suffix-personalization) .block-buy-buttons.block-buy-buttons.product-block");
  
  if (PDPaddtoCartForm) {
      var elementOffset = PDPaddtoCartForm.getBoundingClientRect().top + window.scrollY;
      var distance = elementOffset + 50; // 50px below the element

      if (scrollPosition > distance) {
        PDPaddtoCartForm.classList.add("make-fix");
      } else {
        PDPaddtoCartForm.classList.remove("make-fix");
      }
  }
}
function addtoCartBlockClickWhenFixed( ele ) {

  
}

window.addEventListener("scroll", addtoCartCheckScroll);

var PDPaddtoCartBtn = document.querySelector(".block-buy-buttons.block-buy-buttons.product-block button");

if(PDPaddtoCartBtn){
  PDPaddtoCartBtn.addEventListener("click", function( event ){
    var PDPaddtoCartForm = PDPaddtoCartBtn.closest(".block-buy-buttons.product-block");
  
    if(PDPaddtoCartForm && PDPaddtoCartForm.classList.contains('make-fix')){
      event.preventDefault();
  
      if (PDPaddtoCartForm) {
        document.querySelector('.product-grid__content.product--description').scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  
  });
}

/* GCW Recs: scroll controls + Quick Add + auto-bind when BR renders */
(function () {
  // ===== Quick Add helpers =====
  async function fetchProduct(handle) {
    const res = await fetch(`/products/${encodeURIComponent(handle)}.js`);
    if (!res.ok) throw new Error('Product JSON failed');
    return res.json();
  }
  function firstAvailableVariant(product) {
    return product.variants.find(v => v.available) || product.variants[0];
  }
  async function addToCart(variantId, qty = 1) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty })
    });
    if (!res.ok) throw new Error('Add to cart failed');
    return res.json();
  }
  function tryOpenDrawer(detail) {
    try { if (window.theme?.cart?.openDrawer) { theme.cart.openDrawer(detail); return; } } catch(e){}
    try { if (window.Shopify?.theme?.cart?.showDrawer) { Shopify.theme.cart.showDrawer(detail); return; } } catch(e){}
    document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail }));
  }

  // ===== Per-widget initializer =====
  function init(container) {
    if (!container || container.dataset.gcwRecsBound) return;

    // Scroll buttons (your original logic)
    const scroller = container.querySelector('.gcw-recs__scroller');
    if (scroller) {
      const prev = container.querySelector('.gcw-recs__prev');
      const next = container.querySelector('.gcw-recs__next');
      const item = scroller.querySelector('.gcw-recs__item, .grid-item');

      const gap = () => {
        const cs = getComputedStyle(scroller);
        return parseFloat(cs.columnGap || cs.gap || 0) || 0;
      };
      const step = () => {
        const w = item ? item.getBoundingClientRect().width : scroller.clientWidth * 0.8;
        return w + gap();
      };

      prev && prev.addEventListener('click', () => scroller.scrollBy({ left: -step(), behavior: 'smooth' }));
      next && next.addEventListener('click', () => scroller.scrollBy({ left:  step(), behavior: 'smooth' }));
    }

    // Quick Add delegation (use your markup’s class!)
    container.addEventListener('click', async function(e) {
      const btn = e.target.closest('.js-br-quick-add'); // <-- matches your BR markup
      if (!btn || !container.contains(btn)) return;

      e.preventDefault();
      e.stopPropagation();

      const handle = btn.getAttribute('data-handle');
      if (!handle) return;
console.log('[GCW Recs] Quick Add clicked', handle);
      btn.disabled = true;
      btn.classList.add('is-loading');

      try {
        const product = await fetchProduct(handle);
        // For now: instant add using first available (we can swap to modal later if you want)
        const variantId = firstAvailableVariant(product).id;
        const detail = await addToCart(variantId, 1);
        tryOpenDrawer(detail);
        btn.classList.add('is-added');
        setTimeout(() => btn.classList.remove('is-added'), 800);
      } catch (err) {
        console.error(err);
        document.dispatchEvent(new CustomEvent('gcw:quickAdd:error', { detail: { handle, error: err } }));
      } finally {
        btn.disabled = false;
        btn.classList.remove('is-loading');
      }
    }, { passive: false });

    container.dataset.gcwRecsBound = '1';
  }

  // ===== Scanner to (re)bind widgets =====
  function scan(root = document) {
    root.querySelectorAll('.gcw-recs').forEach(init);
  }

  // DOM ready + Shopify editor section events
  if (document.readyState !== 'loading') scan();
  else document.addEventListener('DOMContentLoaded', () => scan());

  document.addEventListener('shopify:section:load', e => scan(e.target));
  document.addEventListener('shopify:section:unload', e => scan(e.target));

  // Rebind when Bloomreach injects/upgrades the widget
  const mo = new MutationObserver(muts => muts.forEach(m => scan(m.target)));
  mo.observe(document.body, { childList: true, subtree: true });
})();

/* TEMP DIAG: catch quick-add clicks at the document level (capture phase) */
document.addEventListener('click', function (e) {
  const btn = e.target.closest('.js-br-quick-add');
  if (!btn) return;
  console.log('[GCW Recs][GLOBAL] Quick Add clicked', btn.dataset.handle);
  // prevent navigation while testing
  e.preventDefault();
  e.stopPropagation();
}, { capture: true, passive: false });